/* eslint-disable no-undef */
import { useTranslation } from 'react-i18next';
import Style from './style';
import { CustomIcon } from 'datastake-daf/dist/components';

const year = new Date().getFullYear();

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <Style>
      <div className="container-p app-footer">
        <div className="top">
          <img src={`${process.env.REACT_APP_LANDING_PAGE_URL}assets/icons/datastake-logo-white.svg`} alt="logo" />
          <h1>
            {t('Your data. Your value.')}
          </h1>
          <div className="links">
            <a href={`${process.env.REACT_APP_LANDING_PAGE_URL}contact`}>{t('Contact')}</a>
            <a href={`${process.env.REACT_APP_LANDING_PAGE_URL}terms`}>{t('Terms of Use')}</a>
            <a href={`${process.env.REACT_APP_LANDING_PAGE_URL}privacy`}>{t('Privacy Policy')}</a>
            <a href={`${process.env.REACT_APP_LANDING_PAGE_URL}cookies`}>{t('Cookies')}</a>
          </div>
        </div>
        <div className="bottom-f">
          <div className="left">
            <span>© Datastake {year}</span>
          </div>
          <div className="right">
            <a
              href="https://www.linkedin.com/company/datastake/"
              target="_blank"
              rel="noopener noreferrer">
              <CustomIcon name="Linkedin" />
            </a>
            <a
              href="https://twitter.com/datastake"
              target="_blank"
              rel="noopener noreferrer">
              <CustomIcon name="Twitter" />
            </a>
            <a
              href={process.env.NEXT_PUBLIC_DISCORD_LINK}
              target="_blank"
              rel="noopener noreferrer">
              <CustomIcon name="Discord" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCeliaCGJKglGaKHdso02LFg"
              target="_blank"
              rel="noopener noreferrer">
              <CustomIcon name="Youtube" />
            </a>
          </div>
        </div>
      </div>
    </Style>
  );
}
